// extracted by mini-css-extract-plugin
export default {"page":"Page_page__riGDs","logoWrapper":"Page_logoWrapper__6zNvP","logo":"Page_logo__WOXl6","logoText":"Page_logoText__cRKr2"};